'use strict';

var dialog = require('./dialog'),
    layout = require('./layout'),
    util = require('./util'),
    Constants = require('./constants'),
    CssConstants = require('./cssconstants'),
    $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
    urls = (typeof window !== "undefined" ? window['Urls'] : typeof global !== "undefined" ? global['Urls'] : null),
    googlePay = require('./googlePay');

var options = {
        quantityFieldSelector: 'input[name="Quantity"]',
        minicart: '#mini-cart',
        minicartContent: Constants.CLASS_MINICART_CONTENT,
        preorderButtonSelector: Constants.CLASS_PRE_ORDER_ACTION,
        minicartImage: Constants.CLASS_MINICART_IMAGE,
        minicartDescription: Constants.CLASS_MINICART_PRODUCT_DESCR,
        toggleImage: Constants.CLASS_MINICART_TOGGLE_IMAGE,
        minicartIcon: Constants.CLASS_MINICART_ICON,
        posRelative: CssConstants.M_RELATIVE,
        animatedHide: CssConstants.M_HIDDEN,

        animationDuration: 700
    },

    $cache = {},

    timer = util.getTimer(),
    productName = $('#product-name').val(),
    preOrderMessage = $('#dispatch-date').val();

function initializeConfig(params) {
    options = $.extend({}, options, params);
}

function initializeCache() {
    $cache.document = $(document);
    $cache.quantityFields = $(options.quantityFieldSelector);
    $cache.preorderSelector = $cache.document.find(options.preorderButtonSelector);

    initializeMinicartCache();
}

function initializeMinicartCache() {
    $cache.minicart = $(options.minicart);
    $cache.minicartContent = $cache.minicart.find(options.minicartContent);
}

function initializeEvents() {
    $cache.document
    .on('click', options.minicartIcon, function(event, data) {
        if(!layout.isMobile()) event.preventDefault();
        timer.clear();
        timer.start(0, function() {
            if ($cache.minicartContent.not(':visible').length && !$cache.minicartContent.is(':animated')) {
                slide();
            } else {
                timer.start(100000, close);
            }
        });
    })
    .on('click', '#mini-cart-placeholder', function (event, data) {
        // go with default event handler
        if ($cache.minicartContent.length) {
            return;
        }

        event.preventDefault();
        update(true);
    })
    .on('mouseleave', options.minicart, function (event, data) {
        if ($cache.minicartContent.is(':visible') && !$cache.minicartContent.is(':animated')) {
            timer.clear();
            timer.start(250, close);
        } else {
            timer.clear();
        }
    })
    .on('mouseenter', options.minicart, function (event, data) {
        timer.clear();
    })
    .on('touchstart', '.js-mini-cart-mobile', function (event, data) {
        timer.clear();
    })
    .on('product.addedToCart', function(event, response) {
        // Desktop init happens inside show(); mobile dialog callback re-inits
        // after the visible mini-bag DOM is ready (avoids race with HTML snapshot).
        show(response, true);

        timer.clear();
        timer.start(Resources.MINICART_SLIDEDOWN_TIMEOUT, close);
    })
    .on('product.variation.changed', function (event, data) {
        initializeCache();
    })
    .on('click', options.toggleImage, function() {
        $(this).siblings(options.minicartImage).toggleClass(options.animatedHide);
        $(this).toggleClass(options.animatedHide);

        $(this).parent().find(options.minicartDescription).delay(600).queue(function (next) {
            $(this).toggleClass(options.posRelative);
            next();
        });
    });
}

function show(html, isNeedMinimised, delayToClose) {
    if (html) {
        $cache.minicart.html(html);
    }

    initializeMinicartCache();

    if (layout.isMobile()) {
        if (isNeedMinimised) {
            var $request = $.ajax({
                'url' : urls.getMinicartMinimised
            }).done(function (response) {
                if (response) {
                    showMinicartDialog(response, true, delayToClose);

                    return;
                }

                showMinicartDialog($cache.minicartContent.html(), false, delayToClose);
            });
        } else {
            showMinicartDialog($cache.minicartContent.html(), false, delayToClose);
        }
    } else {
        slide();
        initDeliveryTheshold();
        // Re-init after HTML replace — createButton must run on the live containers
        // (update() + show() would otherwise wipe a previous init).
        googlePay.init();

        $cache.minicart
            .toggleClass(Constants.CLASS_MINICART_EXPANDED, true)
            .trigger('minicart.shown');

        if (typeof delayToClose === 'number') {
            timer.start(delayToClose, close);
        }
    }
}

function showMinicartDialog(dialogHtml, isMinimised, delayToClose) {
    $cache.minicart.toggleClass(Constants.CLASS_MINICART_EXPANDED, true);

    var dialogClass = isMinimised ? 'b-minicart-dialog__minimised' : 'b-minicart-dialog';
    var isModal = !isMinimised;

    dialog.open({
        html: dialogHtml,
        options: {
            width: 'auto',
            dialogClass: dialogClass,
            modal: isModal,
            close: close.bind(0)
        },
        callback: function() {
            if (!isMinimised) {
                initDeliveryTheshold();

                if (layout.isMobile()) {
                    $('body').trigger('layout.lock');
                }
            }

            // Always re-init for minimised and full dialog — GPay is an empty
            // shell that needs createButton() on the dialog DOM (unlike Apple Pay).
            googlePay.init();

            if (typeof delayToClose === 'number') {
                timer.start(delayToClose, close);
            }
        }
    });
}

function slide() {
    timer.clear();

    $cache.minicartContent.slideDown(300, function () {
        $cache.minicart.addClass(Constants.CLASS_MINICART_EXPANDED);
    });
}

function close(delay) {
    timer.clear();

    $cache.minicartContent.slideUp(delay || 300, function () {
        $cache.minicart.removeClass(Constants.CLASS_MINICART_EXPANDED);
    });

    if (layout.isMobile()){
        dialog.close();

        $('body').trigger('layout.unlock');
    }
}

function buildFlyoutHeader(quantity) {
    var flyoutHeaderText = Resources.MOBILE_TO_CART_HEADER;
    if (parseInt(quantity) > 1 || $cache.quantityFields.length > 1) {
        flyoutHeaderText = String.format(flyoutHeaderText, Resources.ITEMS, Resources.HAVE);
    } else {
        flyoutHeaderText = String.format(flyoutHeaderText, Resources.ITEM, Resources.HAS);
    }

    return flyoutHeaderText;
}

function buildFlyoutContent(header, body) {
    var $flyout = $('<div>', {
        'class': 'b-product_added'
    });
    var $flyoutHeader = $('<h2>', {
        'class': 'b-product_added-title',
        'text': $cache.preorderSelector.length ? preOrderMessage : header
    });
    var $flyoutInfo = $('<div>', {
        'class': 'b-product_added-items',
        'html': body
    });
    var $linkToCart = $('<a>', {
        'class': 'b-product_added-actions g-button-additional button-full-width',
        'href': urls.cartShow,
        'text': Resources.BASKET_AND_CHECKOUT
    });

    return $flyout.html($flyoutHeader).append($flyoutInfo).append($linkToCart);
}

function initDeliveryTheshold() {
    var $deliveryThreshold = $(document).find('.js-cart-delivery-threshold');

    if ($deliveryThreshold.length) {
        var deliveryThresholdWidth = (Math.trunc($deliveryThreshold.data('deliveryPriceLevel')) * 100) / Math.trunc($deliveryThreshold.data('deliveryFreePriceLevel')) + '%';

        $deliveryThreshold.find('.js-delivery-indicator').css('width', deliveryThresholdWidth);
        $deliveryThreshold.removeClass('g-hidden');
    }
}

function update(showOnLoad, delayToClose) {
    var $request = $.ajax({
        'url' : urls.minicart
    }).done(function (response) {
        $cache.minicart.html(response);
        googlePay.init();

        initDeliveryTheshold();
        $(document).trigger('minicart.updated');

        initializeCache();
    });

    if (showOnLoad) {
        $request.done(function(response) {
            show(response, false, delayToClose);
        });
    }
}

module.exports = {
    init: function(params) {
        initializeConfig(params);
        initializeCache();
        initializeEvents();
        initDeliveryTheshold();
    },
    update: update,
    close: function(delay) {
        close(delay);
    }
};
